import { IconProps } from './types';

export const PhotoIcon = ({ strokeWidth, ...props }: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40.468 40.468'>
    <g transform='translate(-2.75 -2.75)'>
      <path
        // eslint-disable-next-line max-len
        d='M8.527,4.5H36.716a4.027,4.027,0,0,1,4.027,4.027V36.716a4.027,4.027,0,0,1-4.027,4.027H8.527A4.027,4.027,0,0,1,4.5,36.716V8.527A4.027,4.027,0,0,1,8.527,4.5Z'
        fill='none'
        stroke='#000'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth || '3.5'}
        {...props}
      />
      <path
        d='M16.54,13.52a3.02,3.02,0,1,1-3.02-3.02A3.02,3.02,0,0,1,16.54,13.52Z'
        transform='translate(2.054 2.054)'
        fill='none'
        stroke='#000'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        {...props}
      />
      <path
        d='M39.716,25.067,29.648,15,7.5,37.148'
        transform='translate(1.027 3.594)'
        fill='none'
        stroke='#000'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        {...props}
      />
    </g>
  </svg>
);
